import React from "react";
import SvgContentCalendarDefault from "@/assets/icons/content/calendar/default.svg";

export default function ContentCalendarDefault(props) {
  return <SvgContentCalendarDefault {...props} />;
}
